<template>
	<link-dialog v-model="show"
				 :dialog-class="dialogClass"
				 v-bind="dialogProps"
				 @confirm="handleConfirm"
				 @cancel="handleCancel">
		<link-auto-table
			v-if="!!option"
			ref="table"
			:option="option"
			@dblClick="handleDblClick">
			<slot></slot>
		</link-auto-table>
	</link-dialog>
</template>

<script>
export default {
	name: 'link-object-modal',
	props: {},
	watch: {
		show(val) {
			if (!!val && !this.option.singleSelect && this.$refs.table) {
				this.$refs.table.unselectAll()
				this.$refs.table.clearSearchValue()
			}
		},
	},
	data() {
		return {
			show: false,
			option: null,
			onConfirm: null,
			onCancel: null,
			dialog: null,
		};
	},
	computed: {
		dialogClass() {
			return [
				'link-object-pick-modal',
				{
					'link-object-pick-modal-compat': window.screen.height < 1080
				}
			]
		},
		dialogProps() {
			return Object.assign({}, {
				width: Math.max(window.screen.width / 2, 600) + 'px',
				title: (!!this.option && this.option.title) ? this.option.title : LinkVue.$t('LinkForm.selectPlaceholder'),
				initialized: true,
				confirmButton: true,
				cancelButton: true,
				noPadding: true,
				vertical: 'center',
				horizontal: 'center',
				disabledHideOnConfirm: true,
				enterToConfirm: false,
			}, (this.dialog || {}))
		},
	},
	methods: {
		refreshRender() {
			this.$refs.table.refreshRender();
		},
		handleConfirm() {
			const ret = this.$refs.table.getSelected()
			if (!!this.option.singleSelect) {
				if (!ret) return;
			} else {
				if (!ret || ret.length === 0) {
					this.$dialog.show({message: LinkVue.$t('LinkAutoTable.pleaseSelectAtLeastOneRow')})
					return
				}
			}

			this.show = false
			!!this.onConfirm && this.onConfirm(ret)
		},
		handleCancel() {
			this.show = false
			!!this.onCancel && this.onCancel()
		},
		handleDblClick() {
			!!this.option.singleSelect && !this.option.updateable && this.handleConfirm()
		},
	},
};
</script>
<style lang="scss">
.link-object-pick-modal {
	box-sizing: border-box;

	.link-dialog-body {
		padding: 16px 0;

		.link-auto-table-title {
			display: none;
		}

		.link-auto-table-header {
			padding-top: 0 !important;
		}

		.link-auto-table-footer {
			padding-bottom: 0 !important;
		}
	}

	&.link-object-pick-modal-compat {
		.link-dialog-head {
			height: 28px !important;
		}

		.link-dialog-foot {
			height: 36px !important;
		}

		.link-dialog-body {
			padding: 8px 0;
		}

		.link-auto-table-header {
			padding-bottom: 4px;
		}

		.link-auto-table-footer {
			padding-top: 4px !important;
		}
	}
}
</style>
